import routes from '@modules/stripe/stripe-connected-account/stripe-connected-account-routes';
import store from '@modules/stripe/stripe-connected-account/stripe-connected-account-store';

export default {
  routes,
  store,
};
